import React from "react";
import { Modal, Pressable, StyleSheet, Text, TextInput, View } from "react-native";

/**
 * Full-screen passcode gate for Screen Time and other protected areas.
 */
export function ScreenTimePasscodeGate({
  visible,
  lockedPageLabel = "Screen Time",
  passcodeInput,
  onChangePasscode,
  onUnlock,
  onBack,
  onOpenHelp,
}) {
  return (
    <Modal visible={visible} animationType="fade" onRequestClose={onBack}>
      <View style={styles.screen}>
        <Text style={styles.title}>Screen time locked</Text>
        <Text style={styles.subtitle}>
          Enter your passcode to open {lockedPageLabel}. Block lists and filters stay protected so they are harder to
          bypass.
        </Text>
        <Text style={styles.label}>Passcode</Text>
        <TextInput
          value={passcodeInput}
          onChangeText={onChangePasscode}
          placeholder="••••"
          placeholderTextColor="#9AA0A6"
          style={styles.input}
          secureTextEntry
          keyboardType="number-pad"
          maxLength={12}
          autoFocus
        />
        <Pressable style={[styles.btn, styles.btnPrimary]} onPress={onUnlock}>
          <Text style={styles.btnText}>Unlock</Text>
        </Pressable>
        <Pressable style={[styles.btn, styles.btnHelp]} onPress={onOpenHelp}>
          <Text style={styles.btnText}>Forgot passcode? Help session</Text>
        </Pressable>
        <Pressable style={[styles.btn, styles.btnBack]} onPress={onBack}>
          <Text style={styles.btnText}>Back</Text>
        </Pressable>
      </View>
    </Modal>
  );
}

const styles = StyleSheet.create({
  screen: {
    flex: 1,
    backgroundColor: "#fff",
    padding: 24,
    justifyContent: "center",
  },
  title: { fontSize: 24, fontWeight: "800", color: "#111", marginBottom: 8 },
  subtitle: { fontSize: 14, color: "#6B7280", lineHeight: 20, marginBottom: 20 },
  label: { fontSize: 13, fontWeight: "700", color: "#374151", marginBottom: 6 },
  input: {
    borderWidth: 1,
    borderColor: "#E5E7EB",
    borderRadius: 10,
    paddingHorizontal: 14,
    paddingVertical: 12,
    fontSize: 16,
    backgroundColor: "#FAFAFA",
  },
  btn: {
    paddingVertical: 14,
    borderRadius: 10,
    alignItems: "center",
    marginTop: 10,
  },
  btnPrimary: { backgroundColor: "#1ABC9C" },
  btnHelp: { backgroundColor: "#4F46E5" },
  btnBack: { backgroundColor: "#111" },
  btnText: { color: "#fff", fontWeight: "800", fontSize: 15 },
});
